'use strict'

var schema = require('property-information/html')
var factory = require('./factory')

var html = factory(schema, 'div')
html.displayName = 'html'

module.exports = html



// WEBPACK FOOTER //
// ./node_modules/hastscript/html.js